export default "__VITE_ASSET__de78588e__"